/**
 * Chat Replacer View
 */

define(function(require, exports, module) {
    'use strict';

    var BaseReplacerView = require('common/base.replacer.view');
    var communicationApi = require('modules/api/communication.api');
    var core = require('core');
    var config = require('config');
    var urlUtil = require('util/url.util');

    module.exports = BaseReplacerView.extend({

        loaded: false,

        events: {
            'tap .fn-open-chat': 'handleOpenChat'
        },

        initialize: function(options) {
            this.options = {
                ...options,
                name: ['CHAT_BUTTON', 'chatbutton'].includes(options.name) ? 'CHAT_BUTTON' : 'CHAT_UNREAD'
            };
        },

        handleOpenChat: function(event) {
            event.preventDefault();

            var isEnabled = this._isChatEnabled();

            if (!isEnabled) {
                return;
            }

            const windowStatus = this.api('getWindowStatus');

            if (windowStatus && (windowStatus.activeScreen === 'CHAT_UI__ICON' || windowStatus.hidden)) {
                this.api('maximize');
                communicationApi('inbox') && communicationApi('inbox')('minimize');
            }
        },

        subscribeToApiEvents: function() {
            this.subscribed = true;
            this.api = communicationApi('chat');

            if (!this._isApiLoaded()) {
                this.listenToOnce(core, 'chat:loaded', this.subscribeToApiEvents.bind(this));
            } else {
                this.render();

                this.api('onAdminStatusChange', this.render.bind(this));
                this.api('onUpdateUnreadCount', this.render.bind(this));
            }
        },

        _isApiLoaded: function() {
            if (!this.loaded) {
                this.loaded = this.api && this.api('getConfig');
            }

            return this.loaded;
        },

        _isChatEnabled: function() {
            return config.get('chatWidget') && config.get('chatWidget').enabled;
        },

        render: function() {
            var isEnabled = this._isChatEnabled();
            var hideChatByUrl = urlUtil.getLocationParameterByName('hideChat') === '1';
            var shouldHideButton = !isEnabled
                || this.options.name === 'CHAT_BUTTON' && !config.get('chatWidget').showIcon
                || hideChatByUrl;

            if (shouldHideButton) {
                return this;
            } else if (!this.subscribed) {
                this.subscribeToApiEvents();
            } else {
                this.$el.html(this.tmpl(this.options.name.toLowerCase(), {
                    unreadCount: this.api('getUnreadCount').adminMessagesCount,
                    isAdminAvailable: this.api('getAdminStatus').isAdminAvailable
                }));
            }

            return this;
        }
    }, {
        nameOfReplacers: [
            'CHAT_BUTTON',
            'CHAT_UNREAD'
        ]
    });
});
